import { get } from 'lodash';
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinStateEditSource',
  props: {
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit, create, or readonly?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    tenantId: {
      type: Number,
      required: true
    },
    twinType: {
      type: String,
      required: false,
      default: null
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: () => ({})
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: () => []
    },
    otherStates: {
      type: Array,
      required: false,
      default: () => []
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    stateDefinition: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      numberRule: [v => !!v && /^([0-9]+)\.?([0-9]*)$/.exec(v) !== null || parseFloat(v) === 0 || this.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber')]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filteredDataSources() {
      if (!Array.isArray(this.dataSources)) {
        return [];
      }
      const isVirtualDevice = get(this, 'twinModel.properties.type', '') === 'virtualDevice';
      return this.dataSources.filter(d => {
        if (d.type === 'dynamical-data-routing' && isVirtualDevice) {
          return false;
        }
        return true;
      });
    },
    selectedDataSource() {
      const type = get(this.lclModel, 'properties.binding.type');
      if (!type) {
        return null;
      }
      return this.matchDataSource(this.lclModel.properties.binding.type) || null;
    }
  },
  watch: {
    'lclModel.properties.binding.type': {
      handler() {
        this.lclModel.properties.binding.options = {};
      }
    }
  },
  methods: {
    matchDataSource(type) {
      return this.filteredDataSources.find(d => d.type === type) || {};
    }
  }
};